// core/battle/ManagerRegistry.ts

import { ControlStateMachine } from "@/core/battle/ControlStateMachine";
import { SkillManager } from "@/core/battle/SkillManager";
import { TurnManager } from "@/core/battle/TurnManager";
import { EntityRegistry } from "@/core/battle/EntityRegistry";

/**
 * Singleton registry для battle managers
 * Створюється один раз в BattleScene, доступний скрізь
 */
class ManagerRegistry {
    private static instance: ManagerRegistry | null = null;
    
    public skillManager!: SkillManager;
    public stateMachine!: ControlStateMachine;
    public turnManager!: TurnManager;
    public entityRegistry!: EntityRegistry;
    
    
    private constructor() {
        // private - не можна створити ззовні
    }
    
    /**
     * Ініціалізація менеджерів (викликається в BattleScene)
     */
    static initialize(
        stateMachine: ControlStateMachine,
        skillManager: SkillManager,
        turnManager: TurnManager,
        entityRegistry: EntityRegistry
    ): void {
        if (!ManagerRegistry.instance) {
            ManagerRegistry.instance = new ManagerRegistry();
        }
        
        const registry = ManagerRegistry.instance;
        registry.stateMachine = stateMachine;
        registry.skillManager = skillManager;
        registry.turnManager = turnManager;
        registry.entityRegistry = entityRegistry;
        
        console.log('[ManagerRegistry] Initialized');
    }
    
    /**
     * Отримати інстанс реєстру
     */
    static getInstance(): ManagerRegistry {
        if (!ManagerRegistry.instance) {
            throw new Error('ManagerRegistry not initialized. Create BattleScene first.');
        }
        return ManagerRegistry.instance;
    }
    
    /**
     * Очистити реєстр (для cleanup)
     */
    static destroy(): void {
        ManagerRegistry.instance = null;
        console.log('[ManagerRegistry] Destroyed');
    }
    
    /**
     * Перевірка чи ініціалізовано
     */
    static isInitialized(): boolean {
        return ManagerRegistry.instance !== null;
    }
}

export default ManagerRegistry;